/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_CarriersInputs */

const en_loading_carriers = /** @type {(inputs: Loading_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading carriers...`)
};

const es_loading_carriers = /** @type {(inputs: Loading_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando transportistas...`)
};

/**
* | output |
* | --- |
* | "Loading carriers..." |
*
* @param {Loading_CarriersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const loading_carriers = /** @type {((inputs?: Loading_CarriersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_CarriersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_carriers(inputs)
	return es_loading_carriers(inputs)
});